// ------------------------------------------------------------------------------
// name: mime
// author: mudas
// created: 2025/3/28
// ------------------------------------------------------------------------------

// @ts-ignore
import mime from 'mime/lite';
import { uniq } from 'lodash-es';

/**
 * 检测指定文件扩展名是否在目标列表中
 * - 目标扩展支持多种格式：txt、.txt、text/plain
 *
 * @param path 文件扩展名
 * @param target 目标扩展列表
 *
 * @example
 * matchMimeType('txt', ['js', 'text/plain'])
 * => true
 *
 * matchMimeType('dir/test.txt', ['js', 'text/plain'])
 * => true
 *
 * matchMimeType('.js', ['text/javascript', 'text/plain'])
 * => true
 */
export const matchMimeType = (path: string, target: string[]) => {
  const extension = mime.getType(path); // ⇨ 'text/plain'
  const normalized = normalizeMimeType(target);

  return uniq(normalized).includes(extension);
};

/**
 * 序列化文件类型列表
 * - 目标扩展支持多种格式：txt、.txt、text/plain
 *
 * @param target 目标扩展列表
 *
 * @example
 * normalizeMimeType(['js', 'text/plain'])
 * => ['text/javascript', 'text/plain']
 */
export const normalizeMimeType = (target: string[]) => {
  return target.map(item => {
    return item.includes('/') ? item : mime.getType(item);
  });
};
